import 'webpack-jquery-ui/selectmenu';
import 'jquery-mask-plugin';
import {
    formatSelectValidation,
    formatRecaptchaErrorMessage,
    formatInvalidDropdownFields,
    validateRecaptcha,
} from './formValidation';
import { limitStandardFormSubmission } from './standardFormSubmission';

export default function () {
    (function ($) {
        $('form').on('reset', function (e) {
            $(this).find('.input-clearable :input').val('').trigger('keyup');
        });

        $('.input-group :input').on('focus', function (e) {
            $(this).closest('.input-group').addClass('focus');
        });

        $('.input-group :input').on('blur', function (e) {
            $(this).closest('.input-group').removeClass('focus');
        });

        const mMaskBehavior = function () {
            const mobile = $('[data-rule-mobile]').val();
            return (mobile.indexOf('0') !== 0 && !(mobile.indexOf('+') === 0 && mobile.indexOf('0') === 1)) ? '+00 00 0000 0000' : '000 0000 0000';
        };

        const spOptions = {
            onKeyPress: function (val, e, field, options) {
                field.mask(mMaskBehavior.apply({}, arguments), options);
            },
        };

        $('[data-rule-mobile]').mask(mMaskBehavior, spOptions);

        // Autocomplete
        // ---

        $.fn.initAutocomplete = function () {
            const type = $(this).attr('data-source-type');
            let source = null;

            if (type === 'https' || type === 'http') {
                // Let jQuery UI handle the request
                source = $(this).attr('data-source');
            } else {
                // Scrape source from a select
                const sourceEle = $(`select[name="${$(this).data('source')}"]`);
                source = $.map(sourceEle.find('option'), function (option) {
                    return $(option).attr('value');
                });
            }

            const options = {
                source,
            };

            if ($(this).hasClass('input-autocomplete-select-submit')) {
                // Add submit on selection behaviour
                options.select = function (event, ui) {
                    $(this).val(ui.item.value);
                    $(this).closest('form').submit();
                };
            }

            const autocomplete = $(this).autocomplete(options);

            // Let's apply some inverse logic to avoid modifying every autocomplete
            const applyWidth = !$(this).hasClass('input-autocomplete-free-width');

            // We want to do some <select>-relative positioning, so we'll
            // do it here instead of _resizeMenu (because _resizeMenu) doesn't
            // have the select element scaffolded

            autocomplete.on('autocompleteopen', function () {
                // This needs to run every time to menu opens, because the
                // menu is recreated every time

                const widget = $(this).autocomplete('widget');
                const width = $(this).closest('.input-group').outerWidth();
                const top = widget.position().top + 10;
                const left = widget.position().left - $(this).position().left - 1;

                widget.css({ top, left });

                if (applyWidth) {
                    widget.css({ width });
                }

                $(this).data('positioned', true);
            });
        };

        // Autocomplete/suggestion
        $('.input-autocomplete[data-source]').each(function () {
            $(this).initAutocomplete();
        });

        // Custom select
        // ---

        // Customise selectmenu
        $.widget('app.selectmenu', $.ui.selectmenu, {
            _drawButton: function () {
                this._super();

                // Clear the default icon classes
                this.button.find('.ui-selectmenu-icon').attr('class', 'ui-selectmenu-icon');

                // Support <select data-required-placeholder="String"></select>
                var selected = this.element.find('[selected]');
                var placeholder = this.element.attr('data-required-placeholder');

                if (!selected.length && placeholder) {
                    this.buttonItem.text(placeholder);
                }
            },
        });

        $('.custom-select').selectmenu();

        formatSelectValidation('.custom-select');

        formatRecaptchaErrorMessage('.userform');

        $('.userform .action').on('click', function (e) {
            const validateForm = validateRecaptcha(e);
            if (!validateForm) {
                formatInvalidDropdownFields();
                return;
            }
            const userform = $(this).closest('.userform');
            userform.submit(() => $(this).prop('disabled', true));
        });

        limitStandardFormSubmission();

        // reCaptcha validation - change event
        $('.g-recaptcha').attr('data-callback', 'recaptchaCallback');

        // Clearable
        // ---

        const clearInputBtnClass = 'clear-input';

        // A plugin for .input-group
        $.fn.updateInputState = function () {
            const len = $(this).find(':input').val().length;
            const clearBtn = $(this).find(`.${clearInputBtnClass}`);
            const hasString = len > 0;

            // Toggle spyglass
            $(this).toggleClass('active', hasString);

            // Toggle clear button
            clearBtn.prop('disabled', !hasString);
        };

        $(document).on('click', '.clear-input', function () {
            $(this).closest('.input-group').find(':input').val('')
                .trigger('blur');
            $(this).closest('.input-group').updateInputState();
        });

        $(document).on('keyup', '.input-group.input-clearable :input', function () {
            $(this).closest('.input-group').updateInputState();
        });

        $(document).on('blur keyup', '.input-enable', function () {
            const enable = $($(this).attr('data-enable'));

            if (!enable.length) {
                console.warn(`Could not find "data-enable" ${$(this).attr('data-enable')}`);
                return;
            }

            enable.prop('disabled', $(this).val().length < 1);
        });

        // People filter search form button
        $('#Form_FilterForm_Search').blur(function () {
            if ($(this).val() !== '' || $('#Form_FilterForm_Role') !== '') {
                $('#Form_FilterForm_action_doApply').prop('disabled', false);
            }
        });

        $('#Form_FilterForm_Role').on('selectmenuchange', function () {
            $('#Form_FilterForm_action_doApply').prop('disabled', false);
        });

        $('#Form_FilterForm_Search').on('keyup change', function () {
            if ($(this).val() !== '' || $('#Form_FilterForm_Role') !== '') {
                $('#Form_FilterForm_action_doApply').prop('disabled', false);
            }
        });

        if ($('.userform textarea').length) {
            var textarea = $('.userform textarea');
            if (textarea.data('rule-maxlength') > 0) {
                var maxlength = textarea.data('rule-maxlength');
                textarea.attr('maxlength', maxlength);
                $(`<span class="max-length">${maxlength}</span>`).insertBefore(textarea);
                textarea.on('input change', function (e) {
                    if ($(this).val().length >= maxlength) {
                        e.preventDefault();
                    }
                    $('.max-length').text(maxlength - $(this).val().length);
                });
                if ($('input[name="action_clearForm"]').length) {
                    $('input[name="action_clearForm"]').click(function () {
                        $('.max-length').text(maxlength);
                    });
                }
            }
        }
    })(jQuery);
}
